import { Button, Form, Tab, Tabs } from 'react-bootstrap';
import Breadcrumb from '../components/common/Breadcrumb';
import { useState, useRef } from 'react';
import TransferTokens from '../components/TokenManagement/TransferToken';
import TransferHistory from '../components/TokenManagement/TransferHistory';
import { useNavigate } from 'react-router-dom';

export default function TokenTransferPage() {
  const [activeTab, setActiveTab] = useState('transfer-token');
  const navigate = useNavigate();

  return (
    <>
      <div className="mb-2 d-flex flex-wrap justify-content-between align-items-center gap-2">
        <div>
          <h2 className="fw-bold mb-0">Token Management</h2>
        </div>

        <div className="d-flex justify-content-center">
          <div className="d-flex gap-2 align-items-center flex-wrap">
            <Form.Group className="mb-0">
              <Button
                onClick={() => navigate('/user-management')}
                variant="outline-secondary border-2 rounded-2 text-dark bg-white fw-bold"
              >
                Manage Employees
              </Button>
            </Form.Group>
            <Form.Group className="mb-0">
              <Button
                onClick={() => navigate('/token-management')}
                variant="outline-secondary border-2 rounded-2 text-dark bg-white fw-bold"
              >
                Add Tokens
              </Button>
            </Form.Group>
          </div>
        </div>
      </div>

      <div className="bg-white py-3 rounded-3 px-4">
        <Tabs
          id="transfer-token-tabs"
          activeKey={activeTab}
          onSelect={k => setActiveTab(k!)}
          className={`ks-tabs`}
        >
          <Tab eventKey="transfer-token" title="Transfer Token">
            <TransferTokens activeTab={activeTab} setActiveTab={setActiveTab} />
          </Tab>
          <Tab eventKey="transfer-history" title="Transfer History">
            <TransferHistory activeTab={activeTab} />
          </Tab>
        </Tabs>
      </div>
    </>
  );
}
